export type PlaySessionKind = "daily" | "beta" | "challenge";

export type PlaySessionConfig = {
  kind: PlaySessionKind;
  mapId: string;
  showLeaderboardLink: boolean;
  allowUndo: boolean;
  allowUndoFullTurn: boolean;
  allowRestart: boolean;
};

export function playSessionConfig({
  kind,
  mapId,
}: {
  kind: PlaySessionKind;
  mapId: string;
}): PlaySessionConfig {
  if (kind === "beta") {
    return {
      kind,
      mapId,
      showLeaderboardLink: false,
      allowUndo: true,
      allowUndoFullTurn: true,
      allowRestart: true,
    };
  }
  if (kind === "challenge") {
    return {
      kind,
      mapId,
      showLeaderboardLink: true,
      allowUndo: true,
      allowUndoFullTurn: false,
      allowRestart: false,
    };
  }
  return {
    kind,
    mapId,
    showLeaderboardLink: true,
    allowUndo: true,
    allowUndoFullTurn: true,
    allowRestart: true,
  };
}
